import { Component, Input, OnInit, output, ChangeDetectionStrategy } from "@angular/core";
import { Editor, Toolbar } from "ngx-editor";

@Component({
    selector: 'app-text-editor',
    templateUrl: './text-editor.component.html',
    styleUrls: ['./text-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextEditorComponent implements OnInit {
    
    @Input() htmlContent: string | null = '';
    readonly htmlContentChange = output<string>();
    @Input() placeholder: string = '';
    @Input() disabled: boolean = false;

    editor: Editor;
    editorToolbar: Toolbar = [];

    constructor() {
    }

    ngOnInit() {
        this.editor = new Editor();
        this.editorToolbar = [
        // default value
            ['bold', 'italic', 'underline'],
            ['align_left', 'align_center', 'align_right', 'align_justify'],
            ['ordered_list', 'bullet_list'],
            ['text_color', 'background_color'],
        ];
    }

    onContentChange(newText): void {     
        this.htmlContentChange.emit(newText);
    }
}